export default class UserDetailsViewModel {
    public name: string = '';
    public email: string = '';
    public role: string = '';
}